import React, { useEffect, useState } from "react";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import { Link, useParams, useNavigate } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { BsFillCartCheckFill, BsFillCartPlusFill } from "react-icons/bs";
import { IoChatbubbles } from "react-icons/io5";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useDispatch, useSelector } from "react-redux";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import Ratings from "../components/Ratings";
import { BsHeart } from "react-icons/bs";
import { BsShareFill } from "react-icons/bs";
import Reviews from "../components/Reviews";
import { get_product } from "../store/reducers/homeReducer";
import {
  add_to_card,
  messageClear,
  add_to_wishlist,
} from "../store/reducers/cardReducer";
import toast from "react-hot-toast";

const Details = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const dispatch = useDispatch();
  const { product, relatedProducts, moreProducts } = useSelector(
    (state) => state.home
  );
  const { userInfo } = useSelector((state) => state.auth);
  const { errorMessage, succesmdessage } = useSelector((state) => state.card);
  const [totalReview, setTotalReview] = useState(0);
  const [activeImage, setActiveImage] = useState("");
  const [image, setImage] = useState("");
  const [state, setState] = useState("reviews");
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
    },
    mdtablet: {
      breakpoint: { max: 991, min: 464 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 3,
    },
    mdmobile: {
      breakpoint: { max: 640, min: 0 },
      items: 2,
    },
    xmdobile: {
      breakpoint: { max: 440, min: 0 },
      items: 1,
    },
  };

  const [quantity, setQuantity] = useState(1);

  const inc = () => {
    if (quantity >= product.stock) {
      toast.error("Out of stock");
    } else {
      setQuantity(quantity + 1);
    }
  };

  const dec = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const add_card = () => {
    if (userInfo) {
      dispatch(
        add_to_card({
          userId: userInfo.id,
          quantity,
          productId: product._id,
        })
      );
    } else {
      navigate("/login");
    }
  };

  const add_wishlist = () => {
    if (userInfo) {
      dispatch(
        add_to_wishlist({
          userId: userInfo.id,
          productId: product._id,
          name: product.name,
          price: product.price,
          image: product.images[0],
          discount: product.discount,
          rating: product.rating,
          slug: product.slug,
        })
      );
    } else {
      navigate("/login");
    }
  };

  useEffect(() => {
    dispatch(get_product(slug));
  }, [slug]);

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
    if (succesmdessage) {
      toast.success(succesmdessage);
      dispatch(messageClear());
    }
  }, [errorMessage, succesmdessage]);

  const buy = () => {
    if (userInfo) {
      let price = 0;
      if (product.discount !== 0) {
        price =
          product.price - Math.floor((product.price * product.discount) / 100);
      } else {
        price = product.price;
      }
      const obj = [
        {
          sellerId: product.sellerId,
          shopName: product.shopName,
          price: quantity * (price - Math.floor((price * 5) / 100)),
          products: [
            {
              quantity,
              productInfo: product,
            },
          ],
        },
      ];
      navigate("/shipping", {
        state: {
          products: obj,
          price: price * quantity,
          shipping_fee: 85,
          items: 1,
        },
      });
    } else {
      navigate("/login");
    }
  };

  const shareProduct = () => {
    if (navigator.share) {
      navigator
        .share({
          title: product.name,
          text: `Check out this product: ${product.name}`,
          url: window.location.href,
        })
        .then(() => {
          toast.success("Product shared successfully");
          // console.log('Product shared successfully');
        })
        .catch((error) => {
          toast.error("Network Error");
          // console.error('Error sharing product:', error);
        });
    } else {
      console.log("Web share API not supported");
      // Fallback to other share methods if needed
    }
  };

  return (
    <div className="bg-[whitesmoke]">
      <Headers />
      <div
        className=" md:hidden h-[220px] mt-6 bg-cover bg-no-repeat relative bg-left"
        style={{ backgroundImage: `url(/images/banner/cart.jpg)` }}
      >
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[85%] md:w-[80%] md:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              <h2 className="text-3xl font-bold">PRODUCT DETAILS</h2>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div className="w-[85%] md:w-[80%] flex justify-center lg:w-[90%] h-full mx-auto pt-12 pb-12 xs:pt-5">
          <div className=" w-[800px] md:w-full bg-[white] drop-shadow-md rounded-[10px]">
            <div className="flex md:flex md:flex-col gap-8 md:gap-4 px-10 pt-10 pb-2 md:p-2">
              <div>
                <div className=" md:p-1 md:pt-4 md:w-[100%] md:flex md:justify-center md:items-center">
                  <img
                    className="h-[300px] rounded-[10px] w-[300px]"
                    src={image ? image : product.images?.[0]}
                    alt=""
                  />
                </div>
                <div className="pt-3 ">
                  {product.images && (
                    <Carousel
                      autoPlay={true}
                      infinite={true}
                      responsive={responsive}
                      transitionDuration={700}
                    >
                      {product.images.map((img, i) => {
                        return (
                          <div
                            className="md:pl-[-40px] md:flex md:items-center md:justify-center pl-2"
                            key={i}
                            onClick={() => setImage(img) && setActiveImage(img)}
                          >
                            <img
                              className={`h-[55px] w-[57px] md:h-[100px] md:w-[100px] rounded-[10px] cursor-pointer ${
                                img === activeImage
                                  ? "border border-blue-500"
                                  : ""
                              }`}
                              src={img}
                              alt=""
                            />
                          </div>
                        );
                      })}
                    </Carousel>
                  )}
                </div>
              </div>
              <div className="flex flex-col pt-2 md:pt-0 gap-4 w-1/2">
                <div className="flex">
                  <div className="flex md:hidden justify-start items-center text-md text-slate-400 w-full">
                    <p>Home</p>
                    <span className="pt-1">
                      <MdOutlineKeyboardArrowRight />
                    </span>
                    <p to="/">{product.category}</p>
                    <span className="pt-1">
                      <MdOutlineKeyboardArrowRight />
                    </span>
                    <span>{product.name}</span>
                  </div>
                  <button
                    onClick={shareProduct}
                    className="w-[30px] h-[30px] p-2 md:hidden hover:bg-[#212730] hover:text-white flex justify-center items-center bg-slate-300 rounded-full text-white"
                  >
                    <BsShareFill className="" />
                  </button>
                </div>
                <div className="md:flex sm:justify-center md:justify-center md:gap-8 md:items-center ">
                  <div className="flex items-center  gap-3">
                    <h2 className="text-2xl md:text-lg text-slate-700 font-bold">
                      {product.name}
                    </h2>
                    <span
                      className={`text-${product.stock ? "green" : "red"}-500 ${
                        product.stock ? "bg-green-100" : "bg-red-100"
                      } rounded-[10px] px-2 md:text-sm md:hidden `}
                    >
                      {product.stock ? `In Stock` : "Stock Out"}
                    </span>
                  </div>
                  <button
                    onClick={shareProduct}
                    className="w-[30px] h-[30px] p-2 hover:bg-[#212730] fixed right-5 hover:text-white hidden md:flex justify-center items-center bg-slate-300 rounded-full text-white"
                  >
                    <BsShareFill className="" />
                  </button>
                </div>
                <div className=" md:flex hidden justify-center items-center">
                  <span
                    className={`text-${product.stock ? "green" : "red"}-500 ${
                      product.stock ? "bg-green-100" : "bg-red-100"
                    } rounded-[10px] px-2 md:text-sm  justify-center `}
                  >
                    {product.stock ? `In Stock` : "Stock Out"}
                  </span>
                </div>
                <div className="text-slate-600">
                  <div className="flex justify-start md:justify-center items-center gap-2">
                    <div className="flex text-xl">
                      <Ratings ratings={product.rating} />
                    </div>
                    <span className="text-slate-500">( {totalReview} )</span>
                  </div>
                </div>
                <div className="text-xl  font-semibold items-center flex md:justify-center gap-3 md:gap-2">
                  {product.discount !== 0 ? (
                    <>
                      <h2 className="hidden md:flex text-slate-500 text-base font-medium">
                        Price :
                      </h2>
                      <div className="flex gap-0">
                        <h2 className="line-through text-md md:text-sm md:font-medium text-slate-400">
                          Rs.{product.price}{" "}
                        </h2>
                        <span className="text-md md:text-sm  md:font-medium text-slate-400 ">
                          {" "}
                          (-{product.discount}%)
                        </span>
                      </div>

                      <h2 className="text-red-500 ">
                        Rs.
                        {product.price -
                          Math.floor((product.price * product.discount) / 100)}
                      </h2>
                    </>
                  ) : (
                    <>
                      <h2 className="hidden md:flex text-slate-500 text-base font-medium">
                        Price :
                      </h2>
                      <h2 className="text-slate-700"> Rs.{product.price}</h2>
                    </>
                  )}
                </div>

                {product.stock ? (
                  <>
                    <div className="flex gap-3 md:justify-center items-center">
                      <h2 className="text-slate-500 ">Quantity :</h2>
                      <div className="flex md:flex rounded-lg bg-slate-200 h-[40px] justify-center  items-center text-xl">
                        <div
                          onClick={dec}
                          className="px-6 md:px-5 cursor-pointer "
                        >
                          -
                        </div>
                        <div className="px-5 md:px-4">{quantity}</div>
                        <div
                          onClick={inc}
                          className="px-6 md:px-5 cursor-pointer "
                        >
                          +
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
                <div className="flex gap-3 md:justify-center  pb-4  border-b">
                  <Link
                    to={`/dashboard/chat/${product.sellerId}`}
                    className="w-[50%] relative group px-8 py-2 rounded-lg bg-white isolation-auto flex items-center justify-center gap-1 drop-shadow-lg hover:shadow-teal-500/40 z-10 border-2 border-teal-500 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-right-full before:hover:right-0 before:rounded-full  before:bg-teal-500 before:-z-10  before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700"
                  >
                    Chat{" "}
                    <IoChatbubbles className="text-teal-600 group-hover:text-teal-700" />
                  </Link>

                  <div className="flex flex-row items-center justify-center gap-2">
                    <div
                      onClick={add_wishlist}
                      className="h-[45px] w-[45px] flex justify-center items-center cursor-pointer rounded-lg drop-shadow-lg hover:shadow-lg hover:shadow-rose-500/40 bg-rose-500 text-white"
                    >
                      <BsHeart />
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-center md:justify-center gap-3 md:p-5 pb-5">
                  <button
                    onClick={buy}
                    className="w-full relative group flex items-center justify-center gap-1 md:text-md md:px-4 lg:px-6  px-8 py-2 rounded-lg drop-shadow-lg bg-white isolation-auto z-10 border-2 border-green-300 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-green-500 before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700"
                  >
                    Buy Now{" "}
                    <BsFillCartCheckFill className="text-md md:hidden text-green-700 group-hover:text-green-800" />
                  </button>
                  <button
                    onClick={add_card}
                    className="w-full relative group flex gap-1 justify-center md:text-md items-center md:px-4  px-5 py-2 rounded-lg drop-shadow-lg bg-white isolation-auto z-10 border-2 border-blue-300 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-blue-300 before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700"
                  >
                    Add to Cart
                    <BsFillCartPlusFill className="text-md md:hidden text-blue-500 group-hover:text-blue-700" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="w-[85%] md:w-[80%] lg:w-[90%] h-full mx-auto pb-16">
          <div className="flex flex-wrap">
            <div className="w-[72%] md-lg:w-full">
              <div className="pr-4 md-lg:pr-0">
                <div className="grid grid-cols-2">
                  <button
                    onClick={() => setState("reviews")}
                    className={`py-1 hover:text-white px-5 hover:bg-slate-500 ${
                      state === "reviews"
                        ? "bg-[#212730] text-white"
                        : "bg-slate-200 text-slate-700"
                    } rounded-md`}
                  >
                    Reviews
                  </button>
                  <button
                    onClick={() => setState("description")}
                    className={`py-1 px-5 hover:text-white hover:bg-slate-500 ${
                      state === "description"
                        ? "bg-[#212730] text-white"
                        : "bg-slate-200 text-slate-700"
                    } rounded-md`}
                  >
                    Description
                  </button>
                </div>
                <div>
                  {state === "reviews" ? (
                    <Reviews
                      product={product}
                      updateTotalReview={setTotalReview}
                    />
                  ) : (
                    <p className="py-5 text-slate-600">{product.description}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="w-[28%] md-lg:w-full">
              <div className="pl-4 md-lg:pl-0">
                <div className="px-3 py-2 text-slate-600 rounded-md bg-slate-200">
                  <h2> From {product.shopName}</h2>
                </div>
                <div className="flex flex-col gap-5 mt-3 rounded-md border p-3">
                  {moreProducts.map((p, i) => {
                    return (
                      <Link
                        to={`/product/details/${p.slug}`}
                        className="block group rounded-lg group-hover:shadow-lg hover:bg-gray-200 group-hover:bg-gray-200 transition-all duration-300"
                      >
                        <div className="relative rounded-lg h-[270px] overflow-hidden ">
                          <img
                            className="w-full object-cover rounded-lg h-full transform scale-100 group-hover:scale-105 transition-all duration-300"
                            src={p.images[0]}
                          />
                          {p.discount !== 0 && (
                            <div className="flex justify-center rounded items-center absolute text-white w-[38px] h-[38px] rounded-full bg-red-500 font-semibold text-xs left-2 top-2">
                              {p.discount}%
                            </div>
                          )}
                        </div>
                        <h2 className="text-slate-600 px-2 py-1">{p.name}</h2>
                        <div className="flex px-3 gap-2 py-1">
                          <h2 className="text-slate-600 text-md font-bold">
                            Rs.
                            {p.discount
                              ? p.price -
                                Math.floor((p.price * p.discount) / 100)
                              : p.price}
                          </h2>
                          <div className="flex items-center gap-2">
                            <Ratings ratings={p.rating} />
                          </div>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="w-[85%] md:w-[90%] lg:w-[90%] h-full mx-auto">
          {relatedProducts > 1 && (
            <h2 className="text-2xl py-8 text-slate-600">Related Products</h2>
          )}
          <div>
            <Swiper
              slidesPerView="auto"
              breakpoints={{
                1280: {
                  slidesPerView: 3,
                },
                565: {
                  slidesPerView: 2,
                },
              }}
              spaceBetween={30}
              loop={true}
              pagination={{
                clickable: true,
                el: ".custom_bullet",
              }}
              modules={[Pagination]}
              className="mySwiper"
            >
              {relatedProducts.map((p, i) => {
                return (
                  <SwiperSlide key={i}>
                    <Link
                      to={`/product/details/${p.slug}`}
                      className="block rounded-[20px] group"
                    >
                      <div className="relative rounded-[20px] group h-[270px]">
                        <div className="w-full rounded-[20px] h-full">
                          <img
                            className="w-full object-cover rounded-[20px] h-full"
                            src={p.images[0]}
                          />
                          <div className="absolute h-full rounded-[20px] w-full top-0 left-0 bg-[#000] opacity-25 group-hover:opacity-50 transition-all duration-500"></div>
                        </div>
                        {p.discount !== 0 && (
                          <div className="flex justify-center items-center absolute text-white w-[38px] h-[38px] rounded-full bg-red-500 font-semibold text-xs left-2 top-2">
                            {p.discount}%
                          </div>
                        )}
                      </div>
                      <div className="p-4 flex absolute w-full bottom-0 rounded-[20px] md-lg:translate-y-[0px] transform translate-y-[100px] overflow-hidden left-0 bg-slate-900 bg-opacity-10 backdrop-blur-md group-hover:translate-y-[0px] transition-all duration-500 flex-col gap-1">
                        <h2 className="text-slate-200 text-lg ">{p.name}</h2>
                        <div className="flex justify-start items-center gap-3">
                          <span className="text-lg text-slate-200 font-bold">
                            Rs.
                            {p.discount
                              ? p.price -
                                Math.floor((p.price * p.discount) / 100)
                              : p.price}
                          </span>
                          <div className="flex">
                            <Ratings ratings={p.rating} />
                          </div>
                        </div>
                      </div>
                    </Link>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
          <div className="w-full flex justify-center items-center py-10 md:pb-[30%]">
            <div className="custom_bullet justify-center gap-3 !w-auto"></div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Details;
